export default "__VITE_ASSET__BIPq5zLN__"